














import {
  Component, Vue, Provide, Prop,
} from 'vue-property-decorator';
import fa from 'element-ui/src/locale/lang/fa';

    @Component({})
export default class extends Vue {
        @Prop({ type: Boolean, default: () => true }) button: any;

        @Prop({ type: Boolean, default: () => true }) pagination: any;

        @Prop({ type: Number, default: () => 1 }) slidesPerView: any;

        @Prop({ type: Number, default: () => 0 }) spaceBetween: any;

        @Prop({ type: Object, default: () => ({}) }) options: any;

        private isIe9:boolean = false;

        private nav:any = {
          next: null,
          prev: null,
        };

        private ie9:any = false;

        private created() {
          this.nav.next = document.getElementById('swiper-button-prev');
          this.nav.prev = document.getElementById('swiper-button-next');
        }

        private init(options) {
          const _this = this;
          const obj = {
            centeredSlides: true,
            watchSlidesProgress: true,
            // 如果需要分页器
            pagination: {
              el: '.swiper-pagination',
            },

            // 如果需要前进后退按钮
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },

            slidesPerView: _this.slidesPerView,
            spaceBetween: _this.spaceBetween,

            // 如果需要滚动条
            scrollbar: {
              el: '.swiper-scrollbar',
            },
            grabCursor: true,
            paginationClickable: true,
          };
          for (const i in this.options) {
            obj[i] = this.options[i];
          }
          let mySwiper:any = null;
          try {
            console.log(options.initialSlide);
            // 尝试创建 ie9 下 swiper 轮播
            mySwiper = new Swiper('#swiper-container',
              {
                slidesPerView: Number(_this.slidesPerView),
                spaceBetween: _this.spaceBetween,
                initialSlide: options.initialSlide || 0,
                watchSlidesProgress: true,
                cssWidthAndHeight: false,
              },
              // obj
            );
            const lastSwiperNode = mySwiper.slides.length - _this.slidesPerView - 1; // 有下标
            console.log('mySwiper');
            console.log(JSON.stringify(mySwiper));
            this.nav.next.onclick = function (e) {
              e.preventDefault();
              mySwiper.swipePrev();
            };
            this.nav.prev.onclick = function (e) {
              e.preventDefault();
              console.log(lastSwiperNode);
              console.log(mySwiper.activeIndex);
              console.log(mySwiper.activeIndex <= lastSwiperNode);
              if (mySwiper.activeIndex <= lastSwiperNode) mySwiper.swipeNext();
            };
            // $('#button .swiper-button-prev').on('click', function(e){
            //     console.log(JSON.stringify(e));
            //     mySwiper.swipePrev();
            // });
            // $('#button .swiper-button-next').on('click', function(e){
            //     console.log(JSON.stringify(e));
            //     mySwiper.swipeNext();
            // });
            this.isIe9 = true;
          } catch (e) {
            console.log('报错了');
            console.log(JSON.stringify(e));
            const Swiper = require('@/assets/js/swiper.js');
            mySwiper = new Swiper('#swiper-container', obj);
          }
          return mySwiper;
        }

        private destroyed() {
          this.nav.next = null;
          this.nav.prev = null;
        }
}
